import { render, staticRenderFns } from "./p12.vue?vue&type=template&id=ed7bd3a0&scoped=true&"
import script from "./p12.vue?vue&type=script&lang=js&"
export * from "./p12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7bd3a0",
  null
  
)

export default component.exports